import Home from './HomeComponent';
import Recap from './RecapComponent';
import { AuthenticationGuard } from './AuthenticationGuardComponent';
import QuizAdmin from './admin/QuizAdminComponent';
import GameAdmin from './admin/GameAdminComponent';
import ImageAdmin from './admin/ImageAdminComponent';
import UserAdmin from './admin/UserAdminComponent';
import AdminMain from  './admin/AdminMainComponent';
import GameNew from './GameNewComponent';

import { Routes, Route } from 'react-router-dom';

function Main() {

    return(
        <Routes>
            <Route exact path="/" element={<Home />} />
            <Route path="/game" element={<GameNew />} />
            <Route path="/game/:quiz_id" element={<GameNew />} />
            <Route path="/recap" element={<Recap />} />
            <Route path="/admin" element={<AuthenticationGuard component={AdminMain} />} />
            <Route path="/admin/quizzes" element={<AuthenticationGuard component={QuizAdmin} />} />
            <Route path="/admin/games" element={<AuthenticationGuard component={GameAdmin} />} />
            <Route path="/admin/images" element={<AuthenticationGuard component={ImageAdmin} />} />
            <Route path="/admin/users" element={<AuthenticationGuard component={UserAdmin} />} />
            <Route path="*" element={<Home />} />
        </Routes>
    )
}

export default Main;